import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import styled from 'styled-components'
import { deleteNotification, getNotificationDetail } from '../../services'
import Actions from '../../components/Actions'
import PageLayout from '../../components/PageLayout'
import moment from 'moment'
import { get } from 'lodash'
import { getBabysittingModeFrom } from '@shared/utils/baby-sitting-modes'
import { AppContext } from '../../Context'

const NotificationPageContainer = styled(PageLayout)`
  display: flex;
  flex-direction: column;
  
  .notif-content {
    white-space: pre-wrap;
    margin: 40px 20px 40px 0;
  }
`

function NotificationPage() {
  const navigate = useNavigate()

  const { babysittingModes } = useContext(AppContext)

  const [notifContent, setNotifContent] = useState({message: null, childName: null} )

  const { id } = useParams()


  useEffect(() => {
    const getContent = async () => {
      const result = await getNotificationDetail(id)
      setNotifContent(result.data.getNotification)
    }
    if (!notifContent.message)
      getContent()
  }, [])

  const onDelete = async () => {
    await deleteNotification(id)
    navigate('/')
  }

  return <NotificationPageContainer
    title="Mes notifications"
    prevLink="/"
  >

    <div className="notif-title" >
      <span>{ moment(get(notifContent, 'createdDate', '')).format('DD/MM') }</span>
      { notifContent.childName && <span> | <strong> { notifContent.childName } </strong></span> }
      { notifContent.babysittingMode && <span> - {getBabysittingModeFrom(babysittingModes, notifContent.babysittingMode, 'name')}</span> }
      { notifContent.title && <div><strong>{notifContent.title}</strong></div> }
    </div>

    <div className="notif-content" dangerouslySetInnerHTML={{__html: notifContent.message}} />

    <Actions
      submitTxt={ 'Supprimer' }
      cancelButtonClass={ 'inverse' }
      onSubmit={ onDelete }
      disableCancel={ true }
    />

  </NotificationPageContainer>
}

export default NotificationPage
